import { render, staticRenderFns } from "./QuoteOrderCreatedStateCard.vue?vue&type=template&id=204d289c&"
import script from "./QuoteOrderCreatedStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteOrderCreatedStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports